import type { QueryClient } from '@tanstack/react-query';
import { invalidateWrites } from '@signalvote/data';
import type { EntityTag } from '@signalvote/shared';

let client: QueryClient | null = null;

/** Points every write set at the app's cache. `main.tsx` calls it once, before the first request. */
export function installServerWrites(queryClient: QueryClient): void {
  client = queryClient;
}

/**
 * Both web doors hand each response's write set here: the api-client through `onWrites`, and
 * `authenticatedFetch` reading the header itself. Every read declaring a written type refreshes.
 */
export function onServerWrites(writes: readonly EntityTag[]): void {
  if (client) void invalidateWrites(client, writes);
}
